// extracted by mini-css-extract-plugin
export default {"menu_content":"menuContent_menu_content__msI4i"};